import { useEffect, useMemo } from 'react'
import { Cloud, Clouds, Sparkles } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { useExpedition } from '../store/useExpedition.js'

const conditions={
  'dawn-clear':{sky:'#879eac',fog:'#82949e',near:58,far:165,cloud:.08},
  'clear-cold':{sky:'#8098a9',fog:'#849ba7',near:56,far:160,cloud:.12},
  'high-thin-cloud':{sky:'#8599a4',fog:'#82939a',near:49,far:145,cloud:.22},
  'bluebird-building':{sky:'#7294ad',fog:'#8ca2ad',near:62,far:175,cloud:.18},
  'wind-building':{sky:'#718692',fog:'#73858c',near:42,far:125,cloud:.34},
  'front-arriving':{sky:'#526574',fog:'#586871',near:28,far:92,cloud:.68},
  whiteout:{sky:'#d5dcdb',fog:'#d7dddc',near:8,far:34,cloud:.9},
  'still-cold':{sky:'#263955',fog:'#34475a',near:38,far:112,cloud:.2},
  'snow-grains':{sky:'#172942',fog:'#344455',near:22,far:70,cloud:.5},
  'clouds-opening':{sky:'#6e8297',fog:'#788b98',near:42,far:136,cloud:.32},
  clearing:{sky:'#8ba5b0',fog:'#8ea1a5',near:62,far:180,cloud:.12},
}

export function Atmosphere({ reducedMotion, lowPower }) {
  const phase=useExpedition(state=>state.weatherPhase)
  const {scene}=useThree()
  const spec=conditions[phase]||conditions['dawn-clear']
  const sky=useMemo(()=>new THREE.Color(spec.sky),[spec.sky])
  const fog=useMemo(()=>new THREE.Color(spec.fog),[spec.fog])
  useEffect(()=>{scene.background=sky;scene.fog=new THREE.Fog(fog,spec.near,spec.far)},[fog,scene,sky,spec.far,spec.near])
  return <>
    {!lowPower&&<Clouds material={undefined} limit={300} range={120}>
      <Cloud seed={2} position={[-14,18,-38]} scale={9} volume={5} color="#dbe2df" speed={reducedMotion?0:.08} opacity={spec.cloud*.55}/>
      <Cloud seed={7} position={[18,15,-48]} scale={12} volume={7} color="#bac8cd" speed={reducedMotion?0:.055} opacity={spec.cloud*.42}/>
      <Cloud seed={11} position={[-2,12,10]} scale={7} volume={4} color="#e7e9e5" speed={reducedMotion?0:.04} opacity={spec.cloud*.3}/>
    </Clouds>}
    <Sparkles count={lowPower?24:70} scale={[55,20,65]} position={[0,5,-10]} size={1} speed={reducedMotion?0:.08} opacity={phase==='whiteout' ? .34 : .12} color="#eac986"/>
  </>
}
